import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef, useEffectEvent } from 'react';
import { green, red } from '@mui/material/colors';
import { Box, CircularProgress, Fab, Tooltip } from '@mui/material';
import { wait } from '../../utils/utils';
import ContentIcon from './ContentIcon';
const ProgressFab = (props) => {
    const { processing = false, success = false, error = false, disabled = false, color = 'default', sx, size = 'medium', tooltip = '', displayPosition = { top: 0, left: 0 }, successIcon, errorIcon, delay, children, onClick, onDelay, } = props;
    const getProgressSize = (buttonSize) => {
        if (buttonSize === 'small')
            return 52;
        if (buttonSize === 'medium')
            return 60;
        return 68;
    };
    const [progressSize, setProgressSize] = useState(() => getProgressSize(size));
    const timerRef = useRef(null);
    const onDoubleClick = () => false;
    const buttonSx = {
        ...(success && {
            'bgcolor': green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
        ...(error && {
            'bgcolor': red[500],
            '&:hover': {
                bgcolor: red[700],
            },
        }),
    };
    const updateProgressSize = useEffectEvent(() => {
        setProgressSize(getProgressSize(size));
    });
    useEffect(() => {
        updateProgressSize();
    }, [size]);
    useEffect(() => {
        if (error || success) {
            if (delay && onDelay) {
                void wait(delay, onDelay).then((id) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    timerRef.current = id;
                });
            }
        }
    }, [delay, error, onDelay, success]);
    return (_jsxs(Box, { sx: { position: 'fixed', ...displayPosition }, children: [_jsx(Tooltip, { title: tooltip, arrow: true, children: _jsx("div", { children: _jsx(Fab, { color: color, sx: sx ?? buttonSx, size: size, disabled: disabled, onClick: onClick, onDoubleClick: onDoubleClick, children: _jsx(ContentIcon, { success: success, successIcon: successIcon, error: error, errorIcon: errorIcon, children: children }) }) }) }), processing && (_jsx(CircularProgress, { size: progressSize, sx: {
                    color: green[500],
                    position: 'absolute',
                    top: -6,
                    left: -6,
                    zIndex: 1,
                } }))] }));
};
export default ProgressFab;
//# sourceMappingURL=ProgressFab.js.map